import { Sub, Sup } from 'features/indicationTriage/cards/ffsCalc/FfsCalcLayout'

/**
 * Canonical FFS field-label constants (JSX). Single source of truth for
 * labels shared across the live Part 4/5 sections and the read-only report
 * snapshot. Presentation only -- no logic, no hooks.
 */

// ---- Data values ----
export const LABEL_TMM = (
  <>
    t<Sub>mm</Sub>
  </>
)
export const LABEL_TRD = (
  <>
    t<Sub>rd</Sub>
  </>
)
export const LABEL_TC = (
  <>
    t<Sub>c</Sub>
  </>
)
export const LABEL_D_INNER = (
  <>
    D<Sub>inner</Sub>
  </>
)
export const LABEL_D_OUTER = (
  <>
    D<Sub>outer</Sub>
  </>
)
export const LABEL_T_ML = (
  <>
    t<Sub>ml</Sub>
  </>
)
export const LABEL_D_ML = (
  <>
    D<Sub>ml</Sub>
  </>
)
export const LABEL_NOMINAL = <>Nominal</>
export const LABEL_LAMBDA = <>λ</>
export const LABEL_CORROSION_LOCATION = <>Thinning surface</>

// ---- User params ----
export const LABEL_FCA = <>FCA</>
export const LABEL_FCA_ML = (
  <>
    FCA<Sub>ml</Sub>
  </>
)

// ---- MAWP ----
export const LABEL_QUALITY_FACTOR = <>E</>
export const LABEL_PRESSURE_COEFFICIENT = <>Y</>
export const LABEL_JOINT_EFFICIENCY = <>W</>
export const LABEL_ALLOWABLE_STRESS = <>S</>
export const LABEL_TSL = (
  <>
    t<Sub>sl</Sub>
  </>
)
export const LABEL_MAWP_RC = (
  <>
    MAWP
    <Sup>C</Sup>
  </>
)
export const LABEL_MAWP_RL = (
  <>
    MAWP
    <Sup>L</Sup>
  </>
)
export const LABEL_MAWP_R = (
  <>
    MAWP<Sub>r</Sub>
  </>
)
export const LABEL_MAWP_DESIGN = <>Design Press</>

// ---- Part 4 calculated values ----
export const LABEL_R_T = (
  <>
    R<Sub>t</Sub>
  </>
)
export const LABEL_RSFA = (
  <>
    RSF<Sub>a</Sub>
  </>
)
export const LABEL_Q = <>Q</>
export const LABEL_L = <>L</>
export const LABEL_TS_AM = (
  <>
    t<Sub>am</Sub>
    <Sup>s</Sup>
  </>
)
export const LABEL_TC_AM = (
  <>
    t<Sub>am</Sub>
    <Sup>c</Sup>
  </>
)

// ---- Part 4 thickness criteria ----
export const LABEL_T_LIM = (
  <>
    t<Sub>lim</Sub>
  </>
)
export const LABEL_T_C_MIN = (
  <>
    t<Sub>min</Sub>
    <Sup>c</Sup>
  </>
)
export const LABEL_T_L_MIN = (
  <>
    t<Sub>min</Sub>
    <Sup>L</Sup>
  </>
)
export const LABEL_THICKNESS_CRITERIA = <>Thickness Criteria</>

// ---- Part 5 flaw size / final acceptability ----
export const LABEL_TMM_MINUS_FCA = (
  <>
    t<Sub>mm</Sub> - FCA<Sub>ml</Sub>
  </>
)
export const LABEL_LMSD = (
  <>
    L<Sub>msd</Sub>
  </>
)
export const LABEL_RSF = <>RSF</>
export const LABEL_FOLIAS_FACTOR = (
  <>
    M<Sub>t</Sub>
  </>
)
